module.exports = __webpack_public_path__ + "img/logo-lightbg1.c4916237.svg";